
export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {
    // scripts here fire after init() runs




    /* eslint-disable */
    $( ".component.feature.expandable" ).find( ".read-more" ).click(function(event){
      console.log('expand');
    	event.preventDefault();

      let expandableContent = $(this.parentNode.parentNode).find( ".excerpt" ); //jquery obj

      if (expandableContent.is(":visible")) {
        expandableContent.hide(200);
        $(this).children('span').text($(this).attr("data-open-label"));
        $(this).removeClass('active');

      } else {
        expandableContent.show(200);
        $(this).children('span').text($(this).attr("data-close-label"));
        $(this).addClass('active');

      }

    });
  },
};




// WEBPACK FOOTER //
// ./scripts/components/expandable.js